<template>
  <div id="login-page" class="position-relative h-100 w-100">
    <div
      class="container-login"
      v-if="
        stepIndexActive != stepActive.CHANGE_PASSWORD &&
          stepIndexActive != stepActive.FORGET_PASSWORD
      "
    >
      <video class="video-bg" id="video-element1" autoplay muted loop>
        <source
          src="~@/assets/images/pages/login/BG_Login.mp4"
          type="video/mp4"
        />
      </video>

      <div
        class="text-center w-100 h-100 m-auto"
        v-if="loading.loadingAvailableLogin"
      ></div>
      <div
        class="content-login animate_duration_login animate__fadeIn"
        v-else
        :class="oAuthDisplay.providerList.length < 2 ? '' : 'no-provider'"
      >
        <div class="content-login-left">
          <p>Welcome</p>
          <p>To Dynamic Control System</p>
          <img
            src="~@/assets/images/pages/login/motion_login.png"
            alt=""
            draggable="false"
          />
        </div>
        <div class="content-login-right">
          <!-- header -->
          <div class="content-header">
            <div
              class="d-flex w-100 content-login-right-center"
              :class="
                !resolveShowSocialMedia || oAuthDisplay.providerList.length < 2
                  ? 'no-provider'
                  : ''
              "
            >
              <div class="img-brand-logo"></div>
            </div>
            <div>
              <p>Hello!</p>
              <p>
                Sign in to design your CRM system <br />
                and get closer to your customers
              </p>
            </div>
          </div>

          <div>
            <!-- login -->
            <v-select
              v-if="
                oAuthDisplay.providerList.length > 1 &&
                  stepIndexActive != stepActive.CHANGE_PASSWORD
              "
              :searchable="false"
              class="width-80 m-auto v-select-filter login-v-select-filter"
              :class="
                loginForm.provider_ref ? 'v-select-filter-selected' : null
              "
              v-model="loginForm.provider_ref"
              placeholder="Login Method"
              :options="oAuthDisplay.providerList"
              :reduce="(option) => option"
              :clearable="true"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search vs-height"
                  :required="!loginForm.provider_ref"
                  v-bind="attributes"
                  v-on="events"
                /> </template
            ></v-select>

            <div
              id="login-form-container"
              class=""
              v-if="stepIndexActive == stepActive.LOGIN"
            >
              <div
                v-if="
                  loginForm.provider_ref &&
                    loginForm.provider_ref.oAuthMethod == oAuthMethod.mobileOtp
                "
              >
                <div class="position-relative width-80 m-auto">
                  <b-form class="mt-1" @submit.prevent="onRequestMOTP">
                    <div class="d-flex">
                      <div
                        class="d-flex justify-content-center align-items-center w-40"
                      >
                        <v-select
                          :clearable="false"
                          :searchable="true"
                          id="select-country"
                          class="w-100 m-auto v-select-filter login-v-select-filter"
                          :class="
                            loginForm.mobileCountry
                              ? 'v-select-filter-selected'
                              : null
                          "
                          v-model="loginForm.mobileCountry"
                          :options="optionData.telephoneCountry"
                          :reduce="(option) => option"
                          label="label"
                        >
                          <template #search="{attributes, events}">
                            <input
                              class="vs__search"
                              :required="!loginForm.mobileCountry"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                          <template #option="options">
                            <div class="d-flex">
                              <div
                                class="d-flex justify-content-center align-items-center"
                              >
                                <span class="d-flex">
                                  <Flag
                                    :code="`${options['alpha2']}`"
                                    class="flag-size-m"
                                  />
                                </span>
                                <span class="ml-2 mr-2">{{
                                  options.label
                                }}</span>
                                <span>({{ options.value }})</span>
                              </div>
                            </div>
                          </template>
                          <template #selected-option="options">
                            <div class="d-flex">
                              <div
                                class="d-flex justify-content-center align-items-center"
                              >
                                <!-- <span class="d-flex mr-2">
                                  <Flag
                                    :code="`${options['alpha2']}`"
                                    class="flag-size-m"
                                  />
                                </span> -->
                                <span>({{ options.value }})</span>
                              </div>
                            </div>
                          </template>

                          ></v-select
                        >
                      </div>
                      <div
                        class="d-flex justify-content-end align-items-center w-60 ml-2"
                      >
                        <div class="add-on-border-group m-0 w-100">
                          <b-input-group class="input-group-merge">
                            <!-- <b-input-group-prepend
                              is-text
                              class="add-on-border"
                            >
                              <feather-icon
                                icon="SmartphoneIcon"
                                size="1.5x"
                                class="icon-right-color"
                              />
                            </b-input-group-prepend> -->

                            <b-form-input
                              placeholder="Mobile No."
                              class="add-on-border-input"
                              id="login-phone"
                              v-model="loginForm.mobileNo"
                              name="login-phone"
                              :formatter="onInputNumber"
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="content-sign-in mt-4">
                      <button
                        class="btn-login"
                        type="submit"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        :variant="'primary'"
                        :disabled="
                          loading.signIn ||
                            (loginForm.mobileCountry.alpha2 == 'TH' &&
                              loginForm.mobileNo.length < 9)
                        "
                      >
                        <span>{{ "Sign in" }}</span>
                        <b-spinner
                          v-if="loading.signIn"
                          small
                          class="ml-2 vertical-align-middle"
                        />
                      </button>
                    </div>
                  </b-form>
                </div>
              </div>
              <div v-else>
                <validation-observer ref="loginForm" #default="{}">
                  <b-form class="auth-login-form" @submit.prevent="login">
                    <div class="add-on-border-group mt-1">
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text class="add-on-border">
                          <email-svg class="icon-email-svg" />
                        </b-input-group-prepend>

                        <b-form-input
                          placeholder="Username"
                          class="add-on-border-input"
                          id="login-email"
                          v-model="loginForm.userEmail"
                          name="login-email"
                        />
                      </b-input-group>
                    </div>
                    <div class="add-on-border-group mt-1">
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text class="add-on-border">
                          <lock-svg class="icon-password-svg" />
                        </b-input-group-prepend>
                        <b-form-input
                          placeholder="Password"
                          class="add-on-border-input"
                          id="login-password"
                          v-model="loginForm.password"
                          name="login-password"
                          :type="loginForm.passwordFieldType"
                          autocomplete="password"
                          :formatter="onCheckPassFormat"
                        />
                        <b-input-group-append is-text class="add-on-border">
                          <button
                            type="button"
                            class="btn-show-password"
                            @click="togglePasswordVisibility"
                          >
                            <show-password
                              class="icon-show-password-svg"
                              v-if="loginForm.passwordFieldType === 'password'"
                            />
                            <hide-password
                              class="icon-show-password-svg"
                              v-else
                            />
                          </button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <div class="add-on-border-group mt-1">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div
                          class="content-remember"
                          id="checkbox-custom-control"
                        >
                          <b-form-checkbox
                            v-model="loginForm.rememberMe"
                            value="A"
                            class="custom-control-warning"
                          >
                            <span class="font-medium-3">Remember Me</span>
                          </b-form-checkbox>
                        </div>
                        <!-- <button
                          type="button"
                          class="btn btn-link p-0"
                          @click="onForgetPassword"
                          v-if="oAuthDisplay.providerList.length > 1"
                        >
                          <span class="content-remember font-medium-3"
                            >Forgot Password ?</span
                          >
                        </button> -->
                      </div>
                    </div>
                    <div class="content-sign-in mt-1">
                      <button
                        class="btn-login"
                        type="submit"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        :variant="'primary'"
                        :disabled="loading.signIn"
                      >
                        <span>{{ "Sign in" }}</span>
                        <b-spinner
                          v-if="loading.signIn"
                          small
                          class="ml-2 vertical-align-middle"
                        />
                      </button>
                    </div>
                  </b-form>
                </validation-observer>
              </div>

              <div v-if="resolveShowSocialMedia">
                <div class="content-or">
                  <div class="line-or"></div>
                  <div class="text-or">or</div>
                </div>
                <div class="content-login-iam">
                  <div class="" v-if="oAuthDisplay.google">
                    <img
                      class="w-100"
                      src="~@/assets/images/pages/login/gmail.png"
                      alt=""
                      draggable="false"
                      @click="loginWithOAuth('google')"
                    />
                  </div>
                  <div class="" v-if="oAuthDisplay.facebook">
                    <img
                      class="w-100"
                      src="~@/assets/images/pages/login/facebook.png"
                      alt=""
                      draggable="false"
                      @click="loginWithOAuth('facebook')"
                    />
                  </div>
                  <div class="" v-if="oAuthDisplay.line">
                    <img
                      class="w-100"
                      src="~@/assets/images/pages/login/line.png"
                      alt=""
                      draggable="false"
                      @click="loginWithOAuth('line')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- select brand -->
            <div
              class="width-80 m-auto"
              v-if="stepIndexActive == stepActive.SELECT_BRAND"
            >
              <label for="select-company" class="required">
                {{ "Select Company" }}
              </label>
              <v-select
                :searchable="true"
                id="select-company"
                class="w-100 m-auto v-select-filter login-v-select-filter"
                :class="
                  loginForm.brandRefSelect ? 'v-select-filter-selected' : null
                "
                v-model="loginForm.brandRefSelect"
                placeholder="Select Company"
                :options="brandList"
                :reduce="(option) => option"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search vs-height"
                    :required="!loginForm.provider_ref"
                    v-bind="attributes"
                    v-on="events"
                  /> </template
              ></v-select>
              <div class="content-sign-in btn-select-brand">
                <button
                  class="btn-login"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :variant="'primary'"
                  :disabled="loading.signIn"
                  @click="submitBrand"
                >
                  <span>{{ "Next" }}</span>
                  <b-spinner
                    v-if="loading.signIn"
                    small
                    class="ml-2 vertical-align-middle"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="copyright">© 2022 Choco CRM. All right reserved.</div>
    </div>
    <ChangePasswordPage
      v-if="stepIndexActive == stepActive.CHANGE_PASSWORD"
      :loading="loading.changePassword"
      @onChangePassword="onChangePassword"
    />
    <VerifyOTPPage
      v-if="stepIndexActive == stepActive.VERIFY_OTP"
      :isResendOTP="requestOTPData.isResndOTP"
      :requestOTPData="requestOTPData.data"
      :errorData="requestOTPData.errorData"
      @onResendOTP="onResendRequestOTP"
      @onSubmit="onLoginWithVerifyOTP"
    />
    <ForgetPasswordMainPage
      v-if="stepIndexActive == stepActive.FORGET_PASSWORD"
      :brandRef="loginForm.brandRef"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
// import { required, email } from '@validations';
import VuexyLogo from "@core/layouts/components/Logo.vue";
import EmailSvg from "@/@core/components/svg/common/EmailOpen.vue";
import LockSvg from "@/@core/components/svg/common/Lock.vue";
import ShowPassword from "@/@core/components/svg/common/ShowPassword.vue";
import HidePassword from "@/@core/components/svg/common/HidePassword.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import useLoginAction from "@/views/pages/authentication/login/hooks/useLoginAction";
import { required, email, password } from "@validations";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  onMounted,
  ref,
} from "@vue/composition-api";

import ChangePasswordPage from "@/views/pages/authentication/login/components/ChangePassword.vue";
import VerifyOTPPage from "@/views/pages/authentication/login/components/VerifyOTP.vue";
import ForgetPasswordMainPage from "@/views/pages/authentication/login/ForgetPasswordMain.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    EmailSvg,
    LockSvg,
    vSelect,
    ShowPassword,
    HidePassword,
    ChangePasswordPage,
    VerifyOTPPage,
    ForgetPasswordMainPage,
  },

  setup() {
    const {
      loginForm,
      passwordToggleIcon,
      imageUrl,
      oAuthDisplay,
      resolveShowSocialMedia,
      loading,
      brandList,
      togglePasswordVisibility,
      login,
      loginWithOAuth,
      submitBrand,
      getBrandList,
      selectBrandForm,
      onChangePassword,
      passwordToggle,
      checkPasswordError,
      resetPassword,
      onSuccessModal,
      onCheckPassFormat,
      oAuthMethod,
      optionData,
      onRequestMOTP,
      onLoginWithVerifyOTP,
      requestOTPData,
      onResendRequestOTP,
      onInputNumber,
      onForgetPassword,
      stepIndexActive,
      stepActive,
      fetchBrandInfo,
      getBrandListInfo,
    } = useLoginAction();

    return {
      loginForm,
      passwordToggleIcon,
      imageUrl,
      oAuthDisplay,
      resolveShowSocialMedia,
      loading,
      brandList,
      togglePasswordVisibility,
      login,
      loginWithOAuth,
      submitBrand,
      getBrandList,
      selectBrandForm,
      onChangePassword,
      passwordToggle,
      checkPasswordError,
      resetPassword,
      onSuccessModal,
      onCheckPassFormat,
      oAuthMethod,
      optionData,
      onRequestMOTP,
      onLoginWithVerifyOTP,
      requestOTPData,
      onResendRequestOTP,
      onInputNumber,
      onForgetPassword,
      stepIndexActive,
      stepActive,
      fetchBrandInfo,
      getBrandListInfo,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.animate_duration_login {
  animation-duration: 0.4s;
  -moz-animation-duration: 0.4s;
  -webkit-animation-duration: 0.4s;
  -ms-animation-duration: 0.4s;
}

.icon-right-color {
  color: var(--login-color-content-right);
}

.flag-size-s {
  width: 16px !important;
  height: 12px !important;
}

.flag-size-m {
  width: 20px !important;
  height: 15px !important;
}

.flag-size-l {
  width: 32px !important;
  height: 24px !important;
}
</style>

<style lang="scss">
.login-v-select-filter .vs__dropdown-toggle {
  border-radius: 8px;
  //padding: 0 !important;
}

.login-v-select-filter .vs__dropdown-menu {
  width: 300px !important;
  font-size: larger;
}

.login-v-select-filter .vs__selected-options {
  //padding: 0 !important;
}

.login-v-select-filter .vs__selected {
  //margin: 0 !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
